import { useEffect, useState } from "react";

const QUERY = "(min-width: 1024px)";

/* Horizontal cinematic journey on desktop widths; natural
   vertical flow on phones/tablets where viewport-height
   slides can't hold the content. */
export default function useHorizontalMode() {
  const [horizontal, setHorizontal] = useState(
    () => typeof window !== "undefined" && window.matchMedia(QUERY).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const onChange = (e) => setHorizontal(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return horizontal;
}
